import { IUserName, IApiUser } from 'src/models/users/types';
import { FileStatus, IFileTask } from 'src/common/DocumentsLibrary/types';

export enum DocsNodeType {
  FILE = 'file',
  FOLDER = 'folder'
}
export interface IApiFileNode {
  id: string;
  name: string;
  changedAt: string;
  createDateTime: string;
  createdBy: IApiUser | null;
  nodeType: DocsNodeType;
  getUrl: string;
  putUrl?: string;
  attachedTo: IFileTask[];
  status: FileStatus;
}
export interface IFileNode extends Omit<IApiFileNode, 'createdBy'> {
  createdBy: IUserName | null;
}
export interface IApiFolderNode {
  id: string;
  name: string;
  changedAt: string;
  createDateTime: string;
  createdBy: IApiUser | null;
  nodeType: DocsNodeType;
  children: IDocumentsNode[];
}

export interface IFolderNode extends Omit<IApiFolderNode, 'createdBy'> {
  createdBy: IUserName | null;
}
export type IApiDocumentsNode = IApiFileNode | IApiFolderNode;
export type IDocumentsNode = IFileNode | IFolderNode;
